<div class="login theme-light">
  <div class="login__form">

  <div class="login__header">
      <a [routerLink]="['/login']">
        <img src="/assets/images/biodigital-logo.svg" class="login__logo" data-test="biodigitalLogo">
        <span *appFlagInternal>Loft</span>
      </a>
  </div>

    <div class="login__card">
      <div class="login__body">
        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="login__footer">
        <div class="mt-2 text-center text-12" data-test="privacyAndConditions">&copy; 2019 BioDigital, Inc. All rights reserved. | <a href="https://www.biodigital.com/privacy" target="_blank">Privacy</a> | <a href="https://www.biodigital.com/terms" target="_blank">Terms</a></div>
    </div>
  </div>

  <!-- Login Art -->
  <app-login-art [art]="loginArt" class="login__art" data-test="loginArt"></app-login-art>
</div>
